const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export async function recordLogin(params: {
  user_id: string;
  user_type: 'consultant' | 'workday_client' | 'admin';
  email: string;
  success?: boolean;
  failure_reason?: string;
  session_id?: string;
  company_id?: string | null;
  company_name?: string;
}) {
  try {
    await fetch(`${supabaseUrl}/functions/v1/record-login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${supabaseAnonKey}`,
      },
      body: JSON.stringify(params),
    });
  } catch {
    // Fire-and-forget — never block the login flow
  }
}
